module.exports = "<svg viewBox=\"0 0 24 24\" height=\"24\" width=\"24\" xmlns=\"http://www.w3.org/2000/svg\">\n  <path d=\"M11.5,4.32l-1.37-1.1A1,1,0,0,0,9.5,3h-6a1,1,0,0,0-1,1V17a1,1,0,0,0,1,1H9.15l2.35,1.85Z\" />\n  <path d=\"M20.5,3h-6a1,1,0,0,0-.62.22L12.5,4.32V19.85L14.85,18H20.5a1,1,0,0,0,1-1V4A1,1,0,0,0,20.5,3Z\" />\n</svg>\n"


//////////////////
// WEBPACK FOOTER
// /home/runner/work/web-interactive/web-interactive/lib/images/icons/read.svg
// module id = 814
// module chunks = 1